import { IInternalTransferData } from '../../IInternalTransferData';
import { eInternalTransferCategory } from '../../../../accounting/response/eInternalTransferCategory';

export interface IInternalTransferPostData {
  amountCents?: number;
  category?: eInternalTransferCategory;
  destinationAccountId: string;
  unrestricted: boolean;
  escrowFileId: string;
  sourceAccountId: string;
  cdItemV3Id?: string;
}

export const convertIInternalTransferDataToIInternalTransferPostData = (
  escrowFileId: string,
  { amountCents, category, destinationAccount, cdItemId }: IInternalTransferData,
  depositEscrowBankAccountId: string
): IInternalTransferPostData => ({
  amountCents,
  category,
  destinationAccountId: destinationAccount.id,
  unrestricted: false,
  escrowFileId,
  sourceAccountId: depositEscrowBankAccountId,
  cdItemV3Id: cdItemId,
});
